// @ts-nocheck
/**
 * Iris Group Recruitment Site
 * Main JavaScript File
 */

let mousePosition = { x: 0.5, y: 0.5 };

// p-scroll-story-container 完了後に呼ばれるトリガー (initGalleryRevealMessage が設定)
let _showGalleryMessage: (() => void) | null = null;

// Main entry point is at the bottom of the file

/**
 * Initialize Video Custom Cursor and Modal
 */
function initVideoCursor() {
  const container = document.querySelector('.JS_VideoContainer');
  const cursor = document.querySelector('.JS_VideoPlayCursor');
  const modal = document.querySelector('.JS_VideoModal');
  const modalCloseBtn = document.querySelector('.JS_VideoModalClose');
  const modalVideo = document.querySelector('.JS_ModalVideo');

  if (!container || !modal) return;

  // Custom Cursor Logic
  if (cursor) {
    container.addEventListener('mouseenter', () => {
      cursor.classList.add('is-active');
    });

    container.addEventListener('mouseleave', () => {
      cursor.classList.remove('is-active');
    });

    container.addEventListener('mousemove', (e) => {
      if (window.matchMedia('(max-width: 768px)').matches) return;

      requestAnimationFrame(() => {
        cursor.style.left = `${e.clientX}px`;
        cursor.style.top = `${e.clientY}px`;
      });
    });
  }

  // Modal Logic
  container.addEventListener('click', () => {
    // Hide cursor when modal opens
    if (cursor) cursor.classList.remove('is-active');

    // Open modal and play video
    modal.classList.add('is-open');
    if (modalVideo) {
      if (modalVideo.tagName.toLowerCase() === 'video') {
        modalVideo.currentTime = 0; // Restart video
        modalVideo.play();
      } else if (modalVideo.tagName.toLowerCase() === 'iframe') {
        // YouTube API
        modalVideo.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        // Vimeo API
        modalVideo.contentWindow.postMessage('{"method":"play"}', '*');
      }
    }
  });

  // Close Modal
  const closeModal = () => {
    modal.classList.remove('is-open');
    if (modalVideo) {
      if (modalVideo.tagName.toLowerCase() === 'video') {
        modalVideo.pause();
      } else if (modalVideo.tagName.toLowerCase() === 'iframe') {
        // YouTube API
        modalVideo.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        // Vimeo API
        modalVideo.contentWindow.postMessage('{"method":"pause"}', '*');
      }
    }
  };

  if (modalCloseBtn) {
    modalCloseBtn.addEventListener('click', closeModal);
  }

  // Close modal when clicking outside the video
  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      closeModal();
    }
  });
}

/**
 * Initialize Business Card Flip Triggers
 */
function initBusinessCards() {
  const cards = document.querySelectorAll('.c-business-card');
  cards.forEach(card => {
    card.addEventListener('mouseenter', () => {
      // Only trigger if not already animating
      if (!card.classList.contains('is-animating')) {
        card.classList.add('is-animating');
      }
    });

    // Remove class after animation finishes to allow re-triggering
    const inner = card.querySelector('.c-business-card__inner');
    if (inner) {
      inner.addEventListener('animationend', () => {
        card.classList.remove('is-animating');
      });
    }
  });
}

/**
 * Initialize Culture Page Flip Cards
 */
function initFlipCards() {
  const flipCards = document.querySelectorAll('.JS_FlipCard');
  flipCards.forEach(card => {
    card.addEventListener('click', () => {
      card.classList.toggle('is-flipped');
    });
  });
}

/**
 * Initialize Gallery Photo Reveal
 * Phase 1: Sequential Reveal of Photos (10% → 60% scroll)
 */
function initScrollStory() {
  const wrapper = document.querySelector('.p-gallery-sticky-wrapper') as HTMLElement;
  const gallery = document.querySelector('.p-gallery-reveal') as HTMLElement;
  const items = document.querySelectorAll('.p-gallery-reveal__item') as NodeListOf<HTMLElement>;

  if (!wrapper || !gallery) return;

  // 対策B: iOS（iPhone/iPad/iPod）を判定する。
  // iOS Safari の慣性スクロールと JS の lerp 補間が二重に効くと値が往復して震えるため、
  // iOS のときだけ補間を切って即値で反映する。
  const isIOS = /iP(hone|ad|od)/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  let targetProgress = 0;
  let currentProgress = 0;
  let wrapperTop = 0;
  let wrapperHeight = 0;
  // 対策A: windowHeight を window.innerHeight ではなく clientHeight で持つ。
  // iOS Safari はアドレスバー伸縮で window.innerHeight が頻繁に変わり、
  // progress の分母がブレて画像が小刻みに震える原因になる。
  // clientHeight はその影響を受けにくい。
  let windowHeight = document.documentElement.clientHeight;

  // 対策C: 各画像の直近 opacity を保持しておき、変化があったときだけ DOM を更新する。
  // 9枚すべてに毎フレーム opacity を書き込むと iOS で再合成コストが高く震えやすい。
  const lastOpacity: number[] = new Array(items.length).fill(-1);

  const updateMeasurements = () => {
    const rect = wrapper.getBoundingClientRect();
    wrapperTop = rect.top + window.pageYOffset;
    wrapperHeight = rect.height;
    // 対策A: ここも clientHeight に統一
    windowHeight = document.documentElement.clientHeight;
  };

  updateMeasurements();
  window.addEventListener('resize', updateMeasurements);
  window.addEventListener('load', updateMeasurements);

  let animFrameId: number | null = null;

  // SP(モバイル)判定。SPでは transform を JS から一切書かず opacity だけを更新する。
  // PC は従来どおり translateY の移動つきフェードを行う。
  const isMobileLayout = window.innerWidth <= 768;

  // will-change をアニメーション開始時のみ付与し、終了後に解放する。
  // CSS 側で常時宣言すると 9 枚×GPU レイヤーが描画前から確保されたままになり、
  // iOS Safari のメモリ不足でカクつく。
  // PC 用: will-change の動的管理
  let willChangeActive = false;
  const applyWillChange = () => {
    if (willChangeActive) return;
    willChangeActive = true;
    items.forEach(item => { item.style.willChange = 'transform, opacity'; });
  };
  const releaseWillChange = () => {
    if (!willChangeActive) return;
    willChangeActive = false;
    items.forEach(item => { item.style.willChange = 'auto'; });
  };

  const tick = () => {
    // iOS: JS から opacity を直書きするとスクロールスレッドとの非同期ズレで震える。
    // 代わりに CSS transition + class トグルで GPU コンポジタースレッドに委ねる。
    if (isIOS) {
      currentProgress = targetProgress;
      items.forEach((item, index) => {
        const itemStartThreshold = 0.1 + (index / items.length) * 0.5;
        const revealed = item.classList.contains('is-revealed');
        // ヒステリシス: 表示しきい値と非表示しきい値をずらす。
        // 慣性スクロールの微細な位置変動で class が反復トグルし transition が
        // 連続再起動するのを防ぐ（これが「余韻のある震え」の原因になる）。
        if (!revealed && currentProgress >= itemStartThreshold + 0.08) {
          item.classList.add('is-revealed');
        } else if (revealed && currentProgress < itemStartThreshold - 0.03) {
          item.classList.remove('is-revealed');
        }
      });
      animFrameId = null;
      return;
    }

    if (Math.abs(targetProgress - currentProgress) > 1e-4) {
      currentProgress += 0.15 * (targetProgress - currentProgress);
    } else {
      currentProgress = targetProgress;
    }

    if (currentProgress <= 0 && targetProgress <= 0) {
      items.forEach((item, index) => {
        if (lastOpacity[index] !== 0) {
          item.style.opacity = '0';
          if (!isMobileLayout) {
            item.style.transform = 'translate3d(0, 40px, 0)';
          }
          lastOpacity[index] = 0;
        }
      });
    } else {
      items.forEach((item, index) => {
        const itemStartThreshold = 0.1 + (index / items.length) * 0.5;
        const progressInItem = Math.min(Math.max((currentProgress - itemStartThreshold) / 0.15, 0), 1);

        if (Math.abs(progressInItem - lastOpacity[index]) >= 0.01 ||
          progressInItem === 0 || progressInItem === 1) {
          item.style.opacity = String(progressInItem);
          if (!isMobileLayout) {
            const translateY = Math.round(40 * (1 - progressInItem));
            item.style.transform = `translate3d(0, ${translateY}px, 0)`;
          }
          lastOpacity[index] = progressInItem;
        }
      });
    }

    if (currentProgress === targetProgress) {
      animFrameId = null;
      releaseWillChange();
    } else {
      animFrameId = requestAnimationFrame(tick);
    }
  };

  window.addEventListener('scroll', () => {
    const scrolled = window.pageYOffset;
    const scrollRange = wrapperHeight - windowHeight;
    const progress = scrollRange > 0 ? (scrolled - wrapperTop) / scrollRange : 0;
    targetProgress = Math.min(Math.max(progress, 0), 1);

    // PC のみ will-change を動的管理（iOS は CSS transition が管理する）
    if (!isIOS) applyWillChange();

    if (animFrameId === null) {
      animFrameId = requestAnimationFrame(tick);
    }
  }, { passive: true });
}

/**
 * Initialize Mouse Parallax for Grid
 */
function initMouseParallax() {
  const grid = document.querySelector('.JS_MouseParallaxGrid') as HTMLElement;
  const aura1 = document.querySelector('.JS_MouseParallaxAura1') as HTMLElement;
  const aura2 = document.querySelector('.JS_MouseParallaxAura2') as HTMLElement;
  if (!grid && !aura1 && !aura2) return;

  // マウス操作が発生した時点で初めて will-change を付与（iOS では発火しない）
  let willChangeApplied = false;
  let ticking = false;
  let mouseX = 0;
  let mouseY = 0;

  window.addEventListener('mousemove', (e) => {
    if (!willChangeApplied) {
      willChangeApplied = true;
      if (grid) grid.style.willChange = 'transform';
      if (aura1) aura1.style.willChange = 'transform';
      if (aura2) aura2.style.willChange = 'transform';
    }
    mouseX = (e.clientX / window.innerWidth - 0.5);
    mouseY = (e.clientY / window.innerHeight - 0.5);

    if (!ticking) {
      requestAnimationFrame(() => {
        if (grid) {
          grid.style.transform = `translate3d(${mouseX * 80}px, ${mouseY * 80}px, 0)`;
        }
        if (aura1) {
          aura1.style.transform = `translate3d(${mouseX * 120}px, ${mouseY * 120}px, 0)`;
        }
        if (aura2) {
          aura2.style.transform = `translate3d(${mouseX * -100}px, ${mouseY * -100}px, 0)`;
        }
        ticking = false;
      });
      ticking = true;
    }
  });
}

/**
 * Fetch and include HTML components
 */
async function includeHTML() {
  const includeElements = document.querySelectorAll('[data-include]');

  for (const el of includeElements) {
    const file = el.getAttribute('data-include');

    try {
      const response = await fetch(file);
      if (response.ok) {
        const content = await response.text();
        el.outerHTML = content;
      } else {
        console.error(`Error fetching include: ${file}`);
      }
    } catch (err) {
      console.error(`Fetch exception for ${file}:`, err);
    }
  }
}

/**
 * Initialize scroll animations using Intersection Observer
 */
function initScrollAnimations() {
  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const delay = entry.target.getAttribute('data-delay') || 0;
        entry.target.style.transitionDelay = `${delay}s`;
        entry.target.classList.add('is-visible');
        // Once visible, we can stop observing if it's a one-time animation
        // observer.unobserve(entry.target); 
      } else {
        // Optional: remove class when scrolling away
        // entry.target.classList.remove('is-visible');
      }
    });
  }, options);

  const observeElements = document.querySelectorAll('.JS_ScrollObserve, .JS_ScrollReveal');
  observeElements.forEach(el => observer.observe(el));

  // Trigger Hero animations on load
  setTimeout(() => {
    const heroElements = document.querySelectorAll('.p-hero__bg, .p-hero__member, .JS_ResolutionRise, .p-hero__banners');
    heroElements.forEach(el => el.classList.add('is-visible'));
  }, 100);
}

function initHeroFade() {
  const heroMainVisual = document.querySelector('.p-hero__main-visual') as HTMLElement;
  const heroBanners = document.querySelector('.p-hero__banners') as HTMLElement;
  const philosophy = document.querySelector('#top-philosophy');

  const update = () => {
    const scrolled = window.pageYOffset;

    if (heroMainVisual) {
      const mainOpacity = Math.max(0, 1 - scrolled / 400);
      heroMainVisual.style.opacity = String(mainOpacity);
    }

    if (heroBanners) {
      if (philosophy) {
        const philosophyTop = philosophy.getBoundingClientRect().top;
        const viewportHeight = window.innerHeight;

        // 理念ブロックが画面下端(viewportHeight)に入ってから画面中央(viewportHeight * 0.5)に来るまでにフェードイン
        const fadeStart = viewportHeight;
        const fadeEnd = viewportHeight * 0.5;

        let bannerOpacity = 0;
        if (philosophyTop < fadeStart) {
          bannerOpacity = Math.min(1, Math.max(0, (fadeStart - philosophyTop) / (fadeStart - fadeEnd)));
        }

        heroBanners.style.opacity = String(bannerOpacity);
        heroBanners.style.pointerEvents = bannerOpacity > 0.05 ? 'auto' : 'none';
      } else {
        // フォールバック（通常表示）
        heroBanners.style.opacity = '1';
        heroBanners.style.pointerEvents = 'auto';
      }
    }
  };

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();
}

/**
 * Initialize Parallax and Dynamic Blur
 */
function initParallax() {
  window.addEventListener('scroll', () => {
    const scrolled = window.pageYOffset;
    const parallaxElements = document.querySelectorAll('.JS_Parallax');

    parallaxElements.forEach(el => {
      const depth = el.getAttribute('data-depth') || 0.1;
      const movement = scrolled * depth;

      // Depth Parallax
      el.style.transform = `translateY(${movement}px)`;

      // Dynamic Blur Effect for Hero Background (Concept: Resolution Rise on Scroll)
      if (el.classList.contains('p-hero__bg')) {
        const img = el.querySelector('img');
        if (img) {
          // Increase blur as you scroll away from the top (or decrease if you prefer)
          // Here we make it clear at top, and slightly blur as we scroll down to focus on next section
          const blurValue = Math.min(scrolled / 50, 10);
          img.style.filter = `brightness(0.6) blur(${blurValue}px)`;
        }
      }
    });
  });
}





/**
 * Initialize Synapse Canvas Effect
 */
function initSynapse() {
  const canvas = document.querySelector('.JS_SynapseCanvas');
  if (!canvas) return;

  const ctx = canvas.getContext('2d');
  let width, height;
  let particles = [];

  // Configuration
  const particleCount = 40; // Adjust for density (60 -> 40)
  const connectionDistance = 150; // How close they need to be to connect
  const particleSpeed = 2.0; // Increased movement speed

  // Set canvas size
  function resize() {
    width = window.innerWidth;
    height = window.innerHeight;
    canvas.width = width;
    canvas.height = height;
  }

  window.addEventListener('resize', resize);
  resize();

  // Particle Class
  class Particle {
    constructor() {
      this.x = Math.random() * width;
      this.y = Math.random() * height;
      this.vx = (Math.random() - 0.5) * particleSpeed;
      this.vy = (Math.random() - 0.5) * particleSpeed;
      this.radius = Math.random() * 3.0 + 2.0; // Increased radius
    }

    update() {
      this.x += this.vx;
      this.y += this.vy;

      // Bounce off edges
      if (this.x < 0 || this.x > width) this.vx *= -1;
      if (this.y < 0 || this.y > height) this.vy *= -1;
    }

    draw() {
      ctx.beginPath();
      ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(255, 255, 255, 0.6)';
      ctx.fill();
    }
  }

  // Create particles
  for (let i = 0; i < particleCount; i++) {
    particles.push(new Particle());
  }

  // Animation loop
  function animate() {
    ctx.clearRect(0, 0, width, height);

    // Update and draw particles
    particles.forEach(p => {
      p.update();
      p.draw();
    });

    // Draw connections
    for (let i = 0; i < particles.length; i++) {
      for (let j = i + 1; j < particles.length; j++) {
        const p1 = particles[i];
        const p2 = particles[j];

        // Calculate distance
        const dx = p1.x - p2.x;
        const dy = p1.y - p2.y;
        const distance = Math.sqrt(dx * dx + dy * dy);

        // Draw line if close enough
        if (distance < connectionDistance) {
          // Opacity depends on distance (closer = more opaque)
          const opacity = 1 - (distance / connectionDistance);
          // Multiply opacity to make it subtle
          ctx.strokeStyle = 'rgba(255, 255, 255, ' + (opacity * 0.6) + ')'; // slightly more visible
          ctx.lineWidth = 1.5; // Increased line width
          ctx.beginPath();
          ctx.moveTo(p1.x, p1.y);
          ctx.lineTo(p2.x, p2.y);
          ctx.stroke();
        }
      }
    }

    requestAnimationFrame(animate);
  }

  animate();
}

/**
 * Scroll-triggered animation for the fixed background logo
 */
function initBackgroundLogoScroll() {
  const logo = document.querySelector('.p-top__center-logo, .c-background-logo') as HTMLElement;
  const heroSection = document.querySelector('.p-hero--3d');
  const aboutSection = document.querySelector('.p-top-about');
  const requirementsSection = document.querySelector('.p-top-requirements');

  if (!logo) return;

  const img = logo.querySelector('img') as HTMLElement;
  if (!img) return;

  // Remove CSS transition – inertia is handled in JS
  logo.style.transition = 'none';
  img.style.transition = 'none';

  const sharpImg = logo.querySelector('.JS_LogoSharp') as HTMLElement;
  const blurImg = logo.querySelector('.JS_LogoBlur') as HTMLElement;

  if (sharpImg && blurImg) {
    sharpImg.style.transition = 'none';
    blurImg.style.transition = 'none';
  }

  // Easing: easeOutExpo – fast start, dramatic deceleration
  function easeOutExpo(t) {
    return t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
  }

  // Current (displayed) and target values
  let currentScale = logo.classList.contains('c-background-logo') ? 1.0 : 0.4;
  let currentBlur = logo.classList.contains('c-background-logo') ? 10 : 0; // Top logo starts sharp
  let targetScale = currentScale;
  let targetBlur = currentBlur;

  // Lerp factor: lower = more sluggish inertia (0.03 = very heavy, 0.15 = light)
  const LERP = 0.03;

  // Calculate target values from scroll position
  function getTargetFromScroll() {
    const scrolled = window.pageYOffset;
    const windowHeight = window.innerHeight;
    const scrollHeight = document.documentElement.scrollHeight;
    const maxScroll = scrollHeight - windowHeight;

    // Fallback for subpages (like requirements detail)
    if (!heroSection && !aboutSection) {
      const progress = Math.min(scrolled / Math.max(maxScroll, 1), 1);
      return {
        scale: 1.0 + progress * 0.8,
        blur: 10 + progress * 5
      };
    }

    const heroEnd = aboutSection ? (aboutSection as HTMLElement).offsetTop : windowHeight;

    const anchors = [
      { pos: 0, scale: 0.4, blur: 0, ease: easeOutExpo }, // Starts sharp (blur: 0)
      { pos: heroEnd * 0.30, scale: 3.0, blur: 0, ease: null },
      { pos: heroEnd * 0.90, scale: 3.0, blur: 0, ease: null },
      { pos: (requirementsSection ? (requirementsSection as HTMLElement).offsetTop : maxScroll * 0.5), scale: 0.8, blur: 4, ease: null },
      { pos: maxScroll, scale: 1.8, blur: 8, ease: null }
    ];

    let scale = anchors[0].scale;
    let blur = anchors[0].blur;

    for (let i = 0; i < anchors.length - 1; i++) {
      const a1 = anchors[i];
      const a2 = anchors[i + 1];
      if (scrolled >= a1.pos && scrolled <= a2.pos) {
        let t = (scrolled - a1.pos) / (a2.pos - a1.pos);
        if (a1.ease) t = a1.ease(t);
        scale = a1.scale + t * (a2.scale - a1.scale);
        blur = a1.blur + t * (a2.blur - a1.blur);
        break;
      }
      if (scrolled > anchors[anchors.length - 1].pos) {
        scale = anchors[anchors.length - 1].scale;
        blur = anchors[anchors.length - 1].blur;
      }
    }

    return { scale, blur };
  }

  // RAF handle — null のときループは止まっている
  let logoRafId: number | null = null;

  // Continuous animation loop with lerp inertia
  function animateLogo() {
    currentScale += (targetScale - currentScale) * LERP;
    currentBlur += (targetBlur - currentBlur) * LERP;

    logo.style.transform = `translate3d(-50%, -50%, 0) scale(${currentScale.toFixed(4)})`;

    if (sharpImg && blurImg) {
      // 0〜10pxのぼかし値を 0.0〜1.0 のopacityに変換
      const ratio = Math.min(1.0, Math.max(0.0, currentBlur / 10));
      sharpImg.style.opacity = String(1.0 - ratio);
      blurImg.style.opacity = String(ratio);
    } else {
      img.style.filter = `blur(${currentBlur.toFixed(2)}px)`;
    }

    const scaleDiff = Math.abs(targetScale - currentScale);
    const blurDiff = Math.abs(targetBlur - currentBlur);

    if (scaleDiff > 0.0002 || blurDiff > 0.02) {
      logoRafId = requestAnimationFrame(animateLogo);
    } else {
      currentScale = targetScale;
      currentBlur = targetBlur;
      logo.style.transform = `translate3d(-50%, -50%, 0) scale(${currentScale.toFixed(4)})`;
      if (sharpImg && blurImg) {
        const ratio = Math.min(1.0, Math.max(0.0, currentBlur / 10));
        sharpImg.style.opacity = String(1.0 - ratio);
        blurImg.style.opacity = String(ratio);
      } else {
        img.style.filter = `blur(${currentBlur.toFixed(2)}px)`;
      }
      logoRafId = null;
    }
  }

  // Update target on scroll, restart RAF if stopped
  window.addEventListener('scroll', () => {
    const t = getTargetFromScroll();
    targetScale = t.scale;
    targetBlur = t.blur;
    if (!logoRafId) {
      logoRafId = requestAnimationFrame(animateLogo);
    }
  }, { passive: true });

  // 初回描画
  logoRafId = requestAnimationFrame(animateLogo);
}

/**
 * Initialize Hamburger Menu (100vh fixed layout, no inner scroll)
 */
function initHamburgerMenu() {
  const hamburger = document.querySelector('.JS_Hamburger');
  const header = document.querySelector('.l-header');
  const nav = document.querySelector('.l-header__nav');

  if (!hamburger || !nav) return;

  let savedScrollY = 0;

  const setMenuOpen = (open: boolean) => {
    if (open) {
      savedScrollY = window.scrollY;
    }

    hamburger.classList.toggle('is-active', open);
    nav.classList.toggle('is-active', open);
    header?.classList.toggle('is-menu-open', open);
    document.documentElement.classList.toggle('is-menu-open', open);
    document.body.classList.toggle('is-menu-open', open);
    hamburger.setAttribute('aria-expanded', open ? 'true' : 'false');
    nav.setAttribute('aria-hidden', open ? 'false' : 'true');

    if (open) {
      document.body.style.position = 'fixed';
      document.body.style.top = `-${savedScrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    } else {
      // 一時的にスムーズスクロールを無効化して瞬時に元の位置にジャンプさせる
      const htmlEl = document.documentElement;
      const originalScrollBehavior = htmlEl.style.scrollBehavior;
      htmlEl.style.scrollBehavior = 'auto';

      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo(0, savedScrollY);

      // スクロール処理の完了後に元のスムーズスクロールに戻す
      setTimeout(() => {
        htmlEl.style.scrollBehavior = originalScrollBehavior;
      }, 50);
    }
  };

  const closeMenu = () => setMenuOpen(false);

  hamburger.addEventListener('click', () => {
    setMenuOpen(!hamburger.classList.contains('is-active'));
  });

  nav.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', closeMenu);
  });

  // メニュー表示中は背面スクロールを抑止（採用スペシャル内の縦スクロールのみ許可）
  const navSpecial = nav.querySelector('.l-header__nav-section--special');

  const blockMenuScroll = (e: Event) => {
    if (!nav.classList.contains('is-active')) return;
    const target = e.target as Node | null;
    if (target && navSpecial?.contains(target)) return;
    e.preventDefault();
  };

  nav.addEventListener('wheel', blockMenuScroll, { passive: false });
  nav.addEventListener('touchmove', blockMenuScroll, { passive: false });
}

/**
 * Initialize Header Theme Switching
 */
function initHeaderTheme() {
  const header = document.querySelector('.l-header');
  if (!header) return;

  const sections = document.querySelectorAll('[data-header-theme]');

  const options = {
    root: null,
    rootMargin: '0px 0px -90% 0px', // Trigger when section hits the top area
    threshold: 0
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const theme = entry.target.getAttribute('data-header-theme');
        header.classList.remove('is-theme-dark', 'is-theme-light');
        header.classList.add(`is-theme-${theme}`);
      }
    });
  }, options);

  sections.forEach(section => observer.observe(section));
}

/**
 * Initialize Business Card Modals
 */
function initBusinessModals() {
  const cards = document.querySelectorAll('.JS_BusinessCard');
  const modal = document.querySelector('.JS_BusinessModal') as HTMLElement | null;
  const slider = modal ? modal.querySelector('.JS_BusinessModalSlider') as HTMLElement | null : null;
  const modalCloseBtn = modal ? modal.querySelector('.JS_BusinessModalClose') : null;
  const modalPrevBtn = modal ? modal.querySelector('.JS_BusinessModalPrev') : null;
  const modalNextBtn = modal ? modal.querySelector('.JS_BusinessModalNext') : null;

  if (!cards.length || !modal || !slider) return;

  let currentIndex = 0;

  // 1. Dynamic Slide Generation
  let slidesHTML = '';
  cards.forEach((card, index) => {
    const title = card.getAttribute('data-title') || '';
    const text = card.getAttribute('data-desc') || '';
    const url = card.getAttribute('data-url') || '';
    const logoImg = card.querySelector('.p-business-company__card-logo img') as HTMLImageElement | null;
    const logoSrc = logoImg ? logoImg.src : '';
    const logoAlt = logoImg ? logoImg.alt : '';

    const companyLogo = card.closest('.p-business-company')?.querySelector('.p-business-company__logo img') as HTMLImageElement | null;
    const companyLogoSrc = companyLogo ? companyLogo.src : '';
    const companyLogoAlt = companyLogo ? companyLogo.alt : '';
    const accentColor = card.getAttribute('data-accent') || '#fff';

    slidesHTML += `
      <div class="p-business-company__modal-slide JS_BusinessModalSlide" data-index="${index}" data-accent="${accentColor}">
        <div class="p-business-company__modal-body">
          <div class="p-business-company__modal-logo">
            <img src="${logoSrc}" alt="${logoAlt}">
          </div>
          <h4 class="p-business-company__modal-title">${title}</h4>
          <div class="p-business-company__modal-line" style="background-color: ${accentColor}"></div>
          <p class="p-business-company__modal-text">${text}</p>
          ${url ? `
          <div class="p-business-company__modal-btn-wrapper">
            <a href="${url}" target="_blank" class="c-button p-business-company__modal-btn" style="background-color: ${accentColor}">
              <span>詳細はこちら</span>
              <span class="c-button__arrow"></span>
            </a>
          </div>
          ` : ''}
          <div class="p-business-company__modal-watermark">
            <img src="${companyLogoSrc}" alt="${companyLogoAlt}">
          </div>
        </div>
      </div>
    `;
  });
  slider.innerHTML = slidesHTML;

  const slides = slider.querySelectorAll('.JS_BusinessModalSlide');

  const updateAccentColor = (index: number) => {
    const activeSlide = slides[index] as HTMLElement | null;
    if (activeSlide) {
      const accentColor = activeSlide.getAttribute('data-accent') || '#fff';
      modal.style.setProperty('--accent-color', accentColor);
    }
  };

  const updateModalHeight = () => {
    const activeSlide = slides[currentIndex] as HTMLElement | null;
    if (activeSlide && slider) {
      const body = activeSlide.querySelector('.p-business-company__modal-body') as HTMLElement | null;
      if (body) {
        const height = body.offsetHeight;
        slider.style.height = `${height}px`;
      }
    }
  };

  const syncScrollToActiveIndex = (smooth = false) => {
    const width = slider.clientWidth;
    if (width > 0) {
      slider.scrollTo({
        left: currentIndex * width,
        behavior: smooth ? 'smooth' : 'auto'
      });
    }
  };

  // 2. Open Modal handler
  cards.forEach((card, index) => {
    card.addEventListener('click', () => {
      currentIndex = index;
      updateAccentColor(currentIndex);
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';

      // Sync scroll position once modal rendering is settled
      setTimeout(() => {
        syncScrollToActiveIndex(false);
        updateModalHeight();
      }, 50);
    });
  });

  const closeModal = () => {
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
    if (slider) {
      slider.style.height = '';
    }
  };

  const showPrev = (e: Event) => {
    e.stopPropagation();
    currentIndex = (currentIndex - 1 + cards.length) % cards.length;
    updateAccentColor(currentIndex);
    syncScrollToActiveIndex(true);
    updateModalHeight();
  };

  const showNext = (e: Event) => {
    e.stopPropagation();
    currentIndex = (currentIndex + 1) % cards.length;
    updateAccentColor(currentIndex);
    syncScrollToActiveIndex(true);
    updateModalHeight();
  };

  if (modalCloseBtn) modalCloseBtn.addEventListener('click', closeModal);
  if (modalPrevBtn) modalPrevBtn.addEventListener('click', showPrev);
  if (modalNextBtn) modalNextBtn.addEventListener('click', showNext);

  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      closeModal();
    }
  });

  // 3. Scroll Event (Swipe detection on SP)
  let scrollTimeout: number | null = null;
  slider.addEventListener('scroll', () => {
    if (scrollTimeout !== null) {
      window.clearTimeout(scrollTimeout);
    }
    scrollTimeout = window.setTimeout(() => {
      const width = slider.clientWidth;
      if (width > 0) {
        const index = Math.round(slider.scrollLeft / width);
        if (index !== currentIndex && index >= 0 && index < cards.length) {
          currentIndex = index;
          updateAccentColor(currentIndex);
          updateModalHeight();
        }
      }
    }, 100);
  });

  // 4. Touch swipe (iOS/Android)
  let touchStartX = 0;
  let touchStartY = 0;
  let isHorizontalSwipe: boolean | null = null;

  slider.addEventListener('touchstart', (e: TouchEvent) => {
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
    isHorizontalSwipe = null;
  }, { passive: true });

  slider.addEventListener('touchmove', (e: TouchEvent) => {
    const dx = e.touches[0].clientX - touchStartX;
    const dy = e.touches[0].clientY - touchStartY;
    if (isHorizontalSwipe === null && (Math.abs(dx) > 5 || Math.abs(dy) > 5)) {
      isHorizontalSwipe = Math.abs(dx) > Math.abs(dy);
    }
    if (isHorizontalSwipe) {
      e.preventDefault();
    }
  }, { passive: false });

  slider.addEventListener('touchend', (e: TouchEvent) => {
    if (isHorizontalSwipe) {
      const dx = e.changedTouches[0].clientX - touchStartX;
      if (dx < -50) {
        currentIndex = (currentIndex + 1) % cards.length;
        updateAccentColor(currentIndex);
        syncScrollToActiveIndex(true);
        updateModalHeight();
      } else if (dx > 50) {
        currentIndex = (currentIndex - 1 + cards.length) % cards.length;
        updateAccentColor(currentIndex);
        syncScrollToActiveIndex(true);
        updateModalHeight();
      }
    }
    isHorizontalSwipe = null;
  }, { passive: true });

  // 5. Keyboard navigation
  document.addEventListener('keydown', (e) => {
    if (!modal.classList.contains('is-open')) return;
    if (e.key === 'ArrowLeft') {
      currentIndex = (currentIndex - 1 + cards.length) % cards.length;
      updateAccentColor(currentIndex);
      syncScrollToActiveIndex(true);
      updateModalHeight();
    } else if (e.key === 'ArrowRight') {
      currentIndex = (currentIndex + 1) % cards.length;
      updateAccentColor(currentIndex);
      syncScrollToActiveIndex(true);
      updateModalHeight();
    } else if (e.key === 'Escape') {
      closeModal();
    }
  });

  // 5. Keep slider alignment on window resize
  window.addEventListener('resize', () => {
    if (modal.classList.contains('is-open')) {
      syncScrollToActiveIndex(false);
      updateModalHeight();
    }
  });
}

/**
 * Initialize video playback rate
 */
function initVideoPlaybackRate() {
  const storyVideos = document.querySelectorAll('.p-story-bg__video');
  storyVideos.forEach(video => {
    video.playbackRate = 0.5; // Slow down to 50% speed
  });
}

/**
 * Initialize Entry Form Confirmation Step
 */
function initEntryForm() {
  const form = document.querySelector('.JS_EntryForm');
  if (!form) return;

  const inputView = form.querySelector('.p-form__input-view');
  const confirmView = form.querySelector('.JS_ConfirmView');
  const confirmTrigger = form.querySelector('.JS_ConfirmTrigger');
  const backTrigger = form.querySelector('.JS_BackTrigger');

  if (!inputView || !confirmView || !confirmTrigger || !backTrigger) return;

  // Confirmation Trigger
  confirmTrigger.addEventListener('click', () => {
    // Basic validation
    const inputs = form.querySelectorAll('input[required], textarea[required]');
    let isValid = true;

    inputs.forEach(input => {
      if (!input.checkValidity()) {
        input.reportValidity();
        isValid = false;
        return;
      }
    });

    if (!isValid) return;

    // Check privacy checkbox specifically if needed (reportValidity handles it)
    const privacyCheck = form.querySelector('input[name="privacy"]');
    if (!privacyCheck.checked) {
      privacyCheck.reportValidity();
      return;
    }

    // Reflect values to confirmation view
    const formData = new FormData(form);

    // Type (Radio)
    const typeVal = formData.get('type');
    form.querySelector('.JS_Val_type').textContent = typeVal;

    // Others
    const fields = ['name', 'kana', 'university', 'graduation', 'tel', 'email', 'message'];
    fields.forEach(field => {
      const val = formData.get(field);
      form.querySelector(`.JS_Val_${field}`).textContent = val || '';
    });

    // Switch view
    form.classList.add('is-confirm');
    window.scrollTo({ top: form.offsetTop - 100, behavior: 'smooth' });
  });

  // Back Trigger
  backTrigger.addEventListener('click', () => {
    form.classList.remove('is-confirm');
    window.scrollTo({ top: form.offsetTop - 100, behavior: 'smooth' });
  });

  // Handle actual submission (optional: add loading state)
  form.addEventListener('submit', (e) => {
    // If you want to simulate a thank you message without page reload:
    // e.preventDefault();
    // alert('送信が完了しました（シミュレーション）');
    // window.location.href = '../thanks/';
  });
}

/**
 * Initialize Blog Filtering with URL Hash support
 */
function initBlogFiltering() {
  const filters = document.querySelectorAll('.JS_BlogFilter');
  const cards = document.querySelectorAll('.JS_BlogCard');

  if (!filters.length || !cards.length) return;

  const applyFilter = (filterValue, shouldScroll = true) => {
    // Update active state in UI
    filters.forEach(f => {
      if (f.getAttribute('data-filter') === filterValue) {
        f.classList.add('is-active');
      } else {
        f.classList.remove('is-active');
      }
    });

    cards.forEach(card => {
      const category = card.getAttribute('data-category');

      if (filterValue === 'all' || category === filterValue) {
        // Show
        card.style.display = 'flex';
        requestAnimationFrame(() => {
          card.style.opacity = '1';
          card.style.transform = 'translateY(0)';
        });
      } else {
        // Hide
        card.style.display = 'none';
        card.style.opacity = '0';
        card.style.transform = 'translateY(20px)';
      }
    });

    // Scroll to top after layout change
    if (shouldScroll) {
      setTimeout(() => {
        const listSection = document.querySelector('.p-blog-list');
        if (listSection) {
          const headerOffset = 100;
          const elementPosition = listSection.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 50);
    }
  };

  // Click event for filter links
  filters.forEach(filter => {
    filter.addEventListener('click', (e) => {
      e.preventDefault();
      const filterValue = filter.getAttribute('data-filter');

      // Update URL Hash without jumping (using pushState for 'all' to clear hash)
      if (filterValue === 'all') {
        history.pushState("", document.title, window.location.pathname + window.location.search);
        applyFilter('all');
      } else {
        window.location.hash = filterValue;
        // Hash change will trigger the applyFilter via event listener below
      }
    });
  });

  // Handle URL change (Back/Forward buttons)
  window.addEventListener('hashchange', () => {
    const hash = window.location.hash.replace('#', '') || 'all';
    applyFilter(hash);
  });

  // Initial check on load
  const initialHash = decodeURIComponent(window.location.hash.replace('#', '')) || 'all';
  if (initialHash !== 'all') {
    applyFilter(initialHash, false); // Don't scroll automatically on first load
  }
}

/**
 * Initialize Blog Detail Navigation Automation
 * Detects author initials and updates back-to-list links accordingly
 */
function initBlogDetailNavigation() {
  const authorInitialEl = document.querySelector('.JS_AuthorInitial');
  const backLinks = document.querySelectorAll('.JS_BackToAuthorList');

  if (!authorInitialEl || !backLinks.length) return;

  const initial = authorInitialEl.textContent.trim();

  backLinks.forEach(link => {
    // Update href to include the author hash
    const currentHref = link.getAttribute('href');
    if (currentHref && !currentHref.includes('#')) {
      link.setAttribute('href', currentHref + '#' + initial);
    }

    // Update text for general buttons
    const span = link.querySelector('span');
    if (span) {
      span.textContent = `${initial}のブログ一覧`;
    }

    // Update text for related link titles
    const title = link.querySelector('.p-related__item-title');
    if (title) {
      title.textContent = `${initial}のブログ一覧`;
    }
  });
}

/**
 * Handle scroll positioning when returning to TOP from subpages
 */
function initReturnToTopPositioning() {
  const isTop = document.body.classList.contains('home') || document.body.classList.contains('p-top');

  if (!isTop) {
    // Subpage: listen to header logo & breadcrumb link clicks
    const topLinks = document.querySelectorAll('.l-header__logo-link, .l-header__logo a, .c-breadcrumb__item a');

    // Dynamically resolve the absolute home URL using the header logo link as reference
    const logoLink = document.querySelector('.l-header__logo-link') as HTMLAnchorElement | null;
    const homeUrl = logoLink ? logoLink.href.replace(/\/$/, '') : window.location.origin.replace(/\/$/, '');

    topLinks.forEach((a) => {
      a.addEventListener('click', () => {
        try {
          const anchorEl = a as HTMLAnchorElement;
          const targetUrlObj = new URL(anchorEl.href);
          const cleanTargetUrl = (targetUrlObj.origin + targetUrlObj.pathname).replace(/\/$/, '');
          const isGoToTop = cleanTargetUrl === homeUrl || cleanTargetUrl.endsWith('/index.html');

          if (isGoToTop && !targetUrlObj.hash && !targetUrlObj.search) {
            sessionStorage.setItem('return_top_anim', 'true');
          }
        } catch (err) {
          // Fallback if URL parsing fails
          const href = a.getAttribute('href');
          if (href) {
            const isGoToTop = href === '/' || href.endsWith('/index.html') || href.endsWith('/renew/') || href === window.location.origin + '/';
            if (isGoToTop && !href.includes('#') && !href.includes('?')) {
              sessionStorage.setItem('return_top_anim', 'true');
            }
          }
        }
      });
    });
  } else {
    // Top page: check if returning from subpage with anim flag
    if (sessionStorage.getItem('return_top_anim') === 'true') {
      sessionStorage.removeItem('return_top_anim');
      const gallery = document.querySelector('#top-gallery-auto') as HTMLElement;
      const philosophy = document.querySelector('#top-philosophy') as HTMLElement;

      if (gallery && philosophy) {
        if ('scrollRestoration' in history) {
          history.scrollRestoration = 'manual';
        }
        document.documentElement.style.scrollBehavior = 'auto';

        const getTargetY = () => {
          const pTop = philosophy.getBoundingClientRect().top + window.pageYOffset;
          return Math.max(0, pTop - window.innerHeight);
        };

        window.scrollTo({ top: getTargetY(), behavior: 'auto' });

        // Lock scroll during load to prevent shifts
        const holdInterval = setInterval(() => {
          window.scrollTo({ top: getTargetY(), behavior: 'auto' });
        }, 50);

        const finishJump = () => {
          // @ts-ignore
          if (finishJump.done) return;
          // @ts-ignore
          finishJump.done = true;
          clearInterval(holdInterval);
          window.scrollTo({ top: getTargetY(), behavior: 'auto' });
          document.documentElement.style.scrollBehavior = '';
        };

        window.addEventListener('load', finishJump);
        setTimeout(finishJump, 2000);
      }
    }
  }
}

/**
 * Initialize Gallery Reveal Message (first visit only)
 * p-scroll-story-container のスクロールが完了したあとに表示する。
 * _showGalleryMessage() が initScrollStory から呼ばれるまで非表示を維持する。
 */
function initGalleryRevealMessage() {
  const messageEl = document.querySelector('.p-gallery-reveal__message');
  if (!messageEl) return;

  // スクロールストーリー完了まで非表示
  messageEl.classList.add('is-hidden');

  if (localStorage.getItem('iris_message_seen')) {
    return;
  }

  const skipBtn = messageEl.querySelector('.p-gallery-reveal__message__skip');
  const content = messageEl.querySelector('.p-gallery-reveal__message--content');
  const allPs = content ? Array.from(content.querySelectorAll('p')) : [];

  if (!allPs.length) return;

  const INTERVAL = 1500;
  const INITIAL_DELAY = 600;
  const FADE_WAIT = 3000;
  const FADE_DURATION = 1200;

  let completed = false;

  const fadeOut = () => {
    if (completed) return;
    completed = true;
    if (skipBtn) {
      (skipBtn as HTMLElement).style.opacity = '0';
      (skipBtn as HTMLElement).style.pointerEvents = 'none';
    }
    messageEl.classList.add('is-fadeout');
    setTimeout(() => {
      messageEl.classList.add('is-hidden');
      localStorage.setItem('iris_message_seen', '1');
    }, FADE_DURATION);
  };

  if (skipBtn) {
    skipBtn.addEventListener('click', fadeOut);
  }

  // initScrollStory から呼ばれるトリガーを登録
  _showGalleryMessage = () => {
    messageEl.classList.remove('is-hidden');

    setTimeout(() => {
      if (skipBtn) {
        (skipBtn as HTMLElement).style.opacity = '1';
        (skipBtn as HTMLElement).style.pointerEvents = 'auto';
      }
    }, INITIAL_DELAY);

    allPs.forEach((p, index) => {
      setTimeout(() => {
        if (completed) return;
        p.classList.add('is-visible');
        if (index === allPs.length - 1) {
          setTimeout(fadeOut, FADE_WAIT);
        }
      }, INITIAL_DELAY + index * INTERVAL);
    });
  };
}

// Initialize all components
const initApp = async () => {
  initGalleryRevealMessage();

  // Load common parts first
  await includeHTML();

  initScrollAnimations();
  initParallax();
  initMouseParallax();
  initBusinessCards();
  initVideoCursor();
  initScrollStory();
  initBackgroundLogoScroll();
  initHamburgerMenu();
  initHeroFade();
  initHeaderTheme();
  initBusinessModals();
  initFlipCards();
  initVideoPlaybackRate();
  initEntryForm();
  initBlogFiltering();
  initReturnToTopPositioning();
  // initBlogDetailNavigation(); // Staff filtering is disabled
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initApp);
} else {
  initApp();
}